import cn from 'classnames'
import React, { FC } from 'react'
import { useDispatch } from "react-redux"
import { Link } from 'react-router-dom'
import { toggleSidebar } from "../../redux/slices/dashboard"
import * as Enums from '../../utils/enums'
import { useAppState } from '../../utils/hooks'
import appRoutes from '../../utils/routes'
import AppLogo from "../Presentational/AppLogo"
import styles from "./style.module.scss"

const MobileHeader: FC<{ sidebar?: boolean }> = ({ sidebar = true }) => {
    const dispatch = useDispatch()
    const { portalAccountDomain, screen } = useAppState()
    const ja = portalAccountDomain === Enums.PortalAccountDomain.TMJP

    return screen === Enums.ScreenSize.Mobile ? (
        <div id="mobile-header" className={styles['mobile-header']}>
            <Link className={cn(styles.logo, { [styles.jp]: ja })} to={appRoutes.dashboard.accounts.root}>
                <AppLogo />
            </Link>
            {sidebar && <div className={styles.bars}
                onClick={() => dispatch(toggleSidebar())}>
                <div className={styles.menu} />
            </div>

            }
        </div >
    ) : null
}


export default MobileHeader
